import { createSlice } from "@reduxjs/toolkit";
import {
  fetchbenefitsThunk,
  createbenefitThunk,
  updatebenefitThunk,
  deletebenefitThunk,
} from "./benifitThunk";

const initialState = {
  benefits: [],
  selectedbenefit: null,
  loading: false,
  error: null,
  currentPage: 1, 
  totalPages: 1, 
  totalbenefits: 0,
};

const benefitslice = createSlice({
  name: "benefit",
  initialState,
  reducers: {
    setSelectedbenefit: (state, action) => {
      state.selectedbenefit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch benefits
      .addCase(fetchbenefitsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchbenefitsThunk.fulfilled, (state, action) => {
        state.benefits = action.payload?.benefits || [];
        state.currentPage = action.payload?.currentPage || 1;
        state.totalPages = action.payload?.totalPages || 1;
        state.totalbenefits = action.payload?.totalBenefits || 0;
        state.loading = false;
      })
      .addCase(fetchbenefitsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      // Create benefit
      .addCase(createbenefitThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createbenefitThunk.fulfilled, (state, action) => {
        state.benefits.push(action.payload);
        state.loading = false;
      })
      .addCase(createbenefitThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      // Update benefit
      .addCase(updatebenefitThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatebenefitThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatebenefitThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      // Delete benefit
      .addCase(deletebenefitThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletebenefitThunk.fulfilled, (state, action) => {
        state.benefits = state.benefits.filter(
          (benefit) => benefit._id !== action.payload
        );
        state.loading = false;
      })
      .addCase(deletebenefitThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
  },
});

// Export actions
export const {
  setSelectedbenefit,
} = benefitslice.actions;

export default benefitslice.reducer;
